import { createActions } from '../../../../context';
import * as actions from './consumer-config.actions';

export const consumerConfig = store => ({
    consumers: [],
    classGroups: [],
    actions: createActions(actions)(store)
});